"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genSpacingClassName = void 0;

var _DeviceSize = _interopRequireDefault(require("./DeviceSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Append class names for padding helpers 
 * @param {string} origClassName 
 * @param {dictionary} props 
 * @category Atoms
 */
var genSpacingClassName = function genSpacingClassName(origClassName, props) {
  var className = origClassName ? origClassName : "";

  var _iterator = _createForOfIteratorHelper(_DeviceSize.default.All),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var size = _step.value;
      var ps = size.postfix.length === 0 ? size.postfix : "-".concat(size.postfix);
      var id = size.id;

      if (props["spacing".concat(id)]) {
        if (props.spacing === true) {
          className += " pad".concat(ps);
        } else {
          var parts = props["spacing".concat(id)].split(' ');
          parts = parts.map(function (p) {
            return p.trim();
          });
          parts = parts.filter(function (p) {
            return p.length > 0;
          });

          if (parts.length === 1) {
            className += " pad-".concat(parts[0]).concat(ps);
          }

          if (parts.length === 2) {
            className += " pt-".concat(parts[0]).concat(ps);
            className += " pb-".concat(parts[0]).concat(ps);
            className += " pl-".concat(parts[1]).concat(ps);
            className += " pr-".concat(parts[1]).concat(ps);
          }

          if (parts.length === 3) {
            className += " pt-".concat(parts[0]).concat(ps);
            className += " pb-".concat(parts[0]).concat(ps);
            className += " pl-".concat(parts[1]).concat(ps);
            className += " pr-".concat(parts[2]).concat(ps);
          }

          if (parts.length === 4) {
            className += " pt-".concat(parts[0]).concat(ps);
            className += " pb-".concat(parts[2]).concat(ps);
            className += " pl-".concat(parts[1]).concat(ps);
            className += " pr-".concat(parts[3]).concat(ps);
          }
        }
      }

      if (props["padding".concat(id)]) {
        if (props["padding".concat(id)] === true) {
          className += " pad".concat(ps);
        } else {
          var _parts = props["padding".concat(id)].split(' ');

          _parts = _parts.map(function (p) {
            return p.trim();
          });
          _parts = _parts.filter(function (p) {
            return p.length > 0;
          });

          if (_parts.length === 1) {
            className += " pad-".concat(_parts[0]).concat(ps);
          }

          if (_parts.length === 2) {
            className += " pt-".concat(_parts[0]).concat(ps);
            className += " pb-".concat(_parts[0]).concat(ps);
            className += " pl-".concat(_parts[1]).concat(ps);
            className += " pr-".concat(_parts[1]).concat(ps);
          }

          if (_parts.length === 3) {
            className += " pt-".concat(_parts[0]).concat(ps);
            className += " pb-".concat(_parts[0]).concat(ps);
            className += " pl-".concat(_parts[1]).concat(ps);
            className += " pr-".concat(_parts[2]).concat(ps);
          }

          if (_parts.length === 4) {
            className += " pt-".concat(_parts[0]).concat(ps);
            className += " pb-".concat(_parts[2]).concat(ps);
            className += " pl-".concat(_parts[1]).concat(ps);
            className += " pr-".concat(_parts[3]).concat(ps);
          }
        }
      }

      if (props["spacingLeft".concat(id)]) {
        if (props["spacingLeft".concat(id)] === true) {
          className += " ml".concat(ps);
        } else {
          className += " pl-".concat(props["spacingLeft".concat(id)]).concat(ps);
        }
      }

      if (props["spacingRight".concat(id)]) {
        if (props["spacingRight".concat(id)] === true) {
          className += " mr".concat(ps);
        } else {
          className += " pr-".concat(props["spacingRight".concat(id)]).concat(ps);
        }
      }

      if (props["spacingTop".concat(id)]) {
        if (props["spacingTop".concat(id)] === true) {
          className += " mt".concat(ps);
        } else {
          className += " pt-".concat(props["spacingTop".concat(id)]).concat(ps);
        }
      }

      if (props["spacingBottom".concat(id)]) {
        if (props["spacingBottom".concat(id)] === true) {
          className += " mb".concat(ps);
        } else {
          className += " pb-".concat(props["spacingBottom".concat(id)]).concat(ps);
        }
      }

      if (props["paddingLeft".concat(id)]) {
        if (props["paddingLeft".concat(id)] === true) {
          className += " ml".concat(ps);
        } else {
          className += " pl-".concat(props["paddingLeft".concat(id)]).concat(ps);
        }
      }

      if (props["paddingRight".concat(id)]) {
        if (props["paddingRight".concat(id)] === true) {
          className += " mr".concat(ps);
        } else {
          className += " pr-".concat(props["paddingRight".concat(id)]).concat(ps);
        }
      }

      if (props["paddingTop".concat(id)]) {
        if (props["spacingTop".concat(id)] === true) {
          className += " mt".concat(ps);
        } else {
          className += " pt-".concat(props["paddingTop".concat(id)]).concat(ps);
        }
      }

      if (props["paddingBottom".concat(id)]) {
        if (props["paddingBottom".concat(id)] === true) {
          className += " mb".concat(ps);
        } else {
          className += " pb-".concat(props["paddingBottom".concat(id)]).concat(ps);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return className;
};

exports.genSpacingClassName = genSpacingClassName;